
import './base.css';
import fonteWaterCooler from './images/fonte-water-cooler-100A.png';
import interfaceFrnRadio from './images/interface-frn-radio.png';
import FtdxFt8 from './images/FTDX-FT8.png';
import estacaoPt2crc from './images/estacao-PT2CRC.jpg';
function Hobbies() {
    return (
        <section id="services" className="s-services">
            <div
                className="row section-header has-bottom-sep"
                data-aos="fade-up"
            >
                <div className="col-full">
                    <h3 className="subhead">Meus Hobbies</h3>
                    <h1 className="display-2">
                        Gosto de construir coisas. Circuitos eletrônicos, radioamadorismo, aeromodelismo e até me aventuro em serralheria.
                    </h1>
                </div>
            </div>

            <div className="row services-list block-1-2 block-tab-full">

                {/* Arquitetura de Software */}
                <div
                    className="col-block service-item"
                    data-aos="fade-up"
                >
                    <div className="service-icon">
                        <i className="icon-cmd"></i>
                    </div>
                    <div className="service-text">
                        <h3 className="h2">
                            Circuitos Eletrônicos
                        </h3>
                        <p>
                            Gosto de testar, projetar e montar circuitos eletrônicos, principalmente para sistemas embarcados e IoT.

                        </p>
                        <div className="hobbies-fotos" data-aos="fade-up">
                            <figure>
                                <img
                                    src={fonteWaterCooler}
                                    alt="Fonte Water Cooler 100A"
                                />
                                <figcaption>
                                    Fonte Water Cooler 100A — projeto de eletrônica
                                </figcaption>
                            </figure>
                            <figure>
                                <img
                                    src={interfaceFrnRadio}
                                    alt="Interface FRN Rádio com AGC"
                                />
                                <figcaption>
                                    Interface FRN Rádio com AGC
                                </figcaption>
                            </figure>
                        </div>
                    </div>
                </div>

                {/* Cloud e DevOps */}
                <div
                    className="col-block service-item"
                    data-aos="fade-up"
                >
                    <div className="service-icon">
                        <i className="icon-cube"></i>
                    </div>
                    <div className="service-text">
                        <h3 className="h2">
                            Radioamadorismo
                        </h3>
                        <p>
                            Sou radioamador - PT2CRC, e faço fonia em diversas bandas. Me intereço em modos digitais como FT8, SSTV e CW. 
                            Possuo QRZ nos meus 2 indicativos: <a href="https://www.qrz.com/db/PU2CRC" target="_blank">PU2CRC</a> e <a href="https://www.qrz.com/db/PT2CRC" target="_blank">PT2CRC</a>.
                        </p>
                    </div>
                    <div className="hobbies-fotos" data-aos="fade-up">
                        
                            <figure>
                                <img
                                    src={FtdxFt8}
                                    alt="Modos Digitais - FTDX FT8"
                                />
                                <figcaption>
                                    Modos Digitais - FTDX FT8
                                </figcaption>
                            </figure>
                            <figure>
                                <img
                                    src={estacaoPt2crc}
                                    alt="Estação PT2CRC"
                                />
                                <figcaption>
                                    Estação de rádio PT2CRC
                                </figcaption>
                            </figure>
                    </div>
                </div>

                {/* Aeromodelismo */}
                <div
                    className="col-block service-item"
                    data-aos="fade-up"
                >
                    <div className="service-icon">
                        <i className="icon-factory"></i>
                    </div>
                    <div className="service-text">
                        <h3 className="h2">
                            Aeromodelismo
                        </h3>
                        <p>
                            Me aventuro com aviões, drones e helicópteros. Em breve colocarei mais informações aqui.
                        </p>
                    </div>
                </div>

                {/* Serralheria */}
                <div
                    className="col-block service-item"
                    data-aos="fade-up"
                >
                    <div className="service-icon">
                        <i className="icon-earth"></i>
                    </div>
                    <div className="service-text">
                        <h3 className="h2">
                            Serralheria
                        </h3>
                        <p>
                            Faço móveis para uso pessoal utilizando metalons e madeiras. Em breve colocarei mais informações aqui também.
                        </p>
                    </div>
                </div>

                

            </div>
        </section>
    );
}

export default Hobbies;
